
<template>
<!-- <lazy-component @show="handler"> -->
  <div class="container">
    <div class="row">
      <div ref="slider" class="col-xs-12 col-sm-12 col-lg-10 col-lg-offset-1 carousel">
        <div class="carousel-inner" @touchstart="startSwipe" @touchmove="moveSwipe" @touchend="endSwipe">
          <div 
            v-for="(item, index) in myCaseStudies" 
            :key="index" 
            class="carousel-container"
            v-show="item.position >= -2 && item.position < 3"
            v-bind:style=" { '-webkit-transition-delay': 'webkit-transform ' + (item.position*0.05) +'s', 'webkit-transform': 'translateX(' + item.position*gap + '%)' } "
            v-bind:class=" { 'carousel-quick': item.position >= 2 && blockRight || item.position <= -2 && blockLeft  } "
            >

            <div class="carousel-template" :class="'carousel-template-'+item.t">

              <div class="carousel-img carousel-img1">
                <image-loader 
                  class="image-loader-container"
                  :imgSrc="'carousel/'+item.img1"
                  >
                </image-loader>
                <div class="carousel-img-overlay" v-bind:class=" { 'active':  item.position !== 0 } "></div>
              </div>
                <div v-if="item.img2" class="carousel-img carousel-img2">
                  <image-loader 
                    class="image-loader-container"
                    :imgSrc="'carousel/'+item.img2"
                    >
                  </image-loader>
                  <div class="carousel-img-overlay" v-bind:class=" { 'active':  item.position !== 0 } "></div>
                </div>
               <div v-if="item.img3" class="carousel-img carousel-img3">
                  <image-loader 
                    class="image-loader-container"
                    :imgSrc="'carousel/'+item.img3"
                    >
                  </image-loader>
                  <div class="carousel-img-overlay" v-bind:class=" { 'active':  item.position !== 0 } "></div>
                </div>

                <label v-html="item.title" v-bind:class=" { 'active':  item.position == 0 } "></label>
              </div>
          </div>
        </div>
<!-- 
        <div class="carousel-background"></div> -->

<!--         <arrow-button :position="1" @click="console.log('CLICKED ME')" v-on:childToParent="clickArrow" ></arrow-button>
        <arrow-button :position="-1" v-on:childToParent="clickArrow" ></arrow-button> -->
        <div class="arrow-button arrow-left" @click="clickArrow(1)">
          <img class="arrow-button-svg arrow-button-svg-dark" :src="'static/img/common/left_dark.svg'" />
          <img class="arrow-button-svg arrow-button-svg-light" :src="'static/img/common/left_light.svg'" />
        </div>
        <div class="arrow-button arrow-right" @click="clickArrow(-1)">
          <img class="arrow-button-svg arrow-button-svg-dark" :src="'static/img/common/left_dark.svg'" />
          <img class="arrow-button-svg arrow-button-svg-light" :src="'static/img/common/left_light.svg'" />
        </div>
      </div>
    </div>
  </div>
<!-- </lazy-component> -->
</template>

<style>

.carousel {
  height:500px;
  position: relative;
}
.carousel-inner {
  position: absolute;
  width: 100%;
  left:0;
  height:100%;
  overflow: visible;
}
.carousel-container {
  width: 90%;
  margin-left:5%;
  position: absolute;
  height:100%;
  transition: transform 0.4s cubic-bezier(0.645, 0.045, 0.355, 1), opacity 0.1s 0.1s cubic-bezier(0.645, 0.045, 0.355, 1);
}
.carousel-quick {
  opacity: 0;
}
.carousel-container label {
  position: absolute;
  font-size: 7px;
  line-height: 9px;
  text-align: left;
  text-transform: uppercase;
  opacity: 0;
  transition: 0.3s 0.3s;
  -webkit-transition: 0.3s 0.3s;
}
.carousel-container label.active {
  opacity: 1;
}
.carousel-button {
  position: absolute;
  background-color: #ff0000;
  top:50%;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
}
.carousel-background {
  position: absolute;
  width:100%;
  height:100%;
  background-color: red;
  opacity: 0.5;
  z-index: 1;
  left:0;
}
.carousel-button-right {
  right:0;
}
.carousel-img {
  position: absolute;
  z-index: 2;
}
.carousel-img img {
  opacity: 0.1;
  transition: 0.6s;
  -webkit-transition: 0.6s;
}
.show-carousel-image {
  opacity: 1!important;
}

.carousel-img-overlay {
  position: absolute;
  background-color: #d1a699;
  width: 100%;
  height: 100%;
  top:0;
  opacity: 0;
  transition: 0.6s;
  -webkit-transition: 0.6s;
}
.carousel-img-overlay.active {
  opacity:0.9;
}
/* SPOTIFY 1 / CLUB SANDWICH TEMPLATE 1 */

/* SPOTIFY 2 / OPEN TABLE - TEMPLATE 2 */

  .carousel-template-1 .carousel-img1 {
    width: 80%;
    height: auto;
    top: 5%;
    left: 14%;
  }
  .carousel-template-1 .carousel-img2 {
    width: 44%;
    left: 46%;
    right: auto;
    bottom: 6%;
  }
  .carousel-template-1 .carousel-img3 {
    height: auto;
    width: 35%;
    left:5%;
    top:35%;
  }
  .carousel-template-1 label {
    top: auto;
    left: 46%;
    bottom: 0;
  }

  .carousel-template-2 .carousel-img1 {
    width: 90%;
    left: 5%;
    right: auto;
    top:20%;
    bottom: auto;
  }
  .carousel-template-2 .carousel-img2 {
    width: 50%;
    left: auto;
    right: 10%;
    bottom: auto;
    top: 0%;
  }
  .carousel-template-2 .carousel-img3 {
    width: 60%;
    right: auto;
    left: 15%;
    bottom: 6%;
    top: auto;
  }
  .carousel-template-2 label {
    left: 15%;
    top: auto;
    bottom: 0;
    width: 50%;
  }

  .carousel-template-3 .carousel-img1 {
    width: 66%;
    top: 0%;
    left: 19%;
  }
  .carousel-template-3 .carousel-img2 {
    width: 50%;
    top: 26%;
    bottom: auto;
    right: auto;
    left: 5%;

  }
  .carousel-template-3 .carousel-img3 {
    width: 70%;
    left: 18%;
    bottom: 9%;
  }
  .carousel-template-3 label {
    bottom: 3%;
    top: auto;
    left: 18%;
  }

  .carousel-template-4 .carousel-img1 {
    width: 75%;
    left: 5%;
    right: auto;
    top:0%;
  }
  .carousel-template-4 .carousel-img2 {
    width: 69%;
    left: auto;
    right: 5%;
    bottom: auto;
    top: 37%;
  }
  .carousel-template-4 .carousel-img3 {
    width: 35%;
    left: 10%;
    right:auto;
    bottom: 6%;
    top: auto;

  }
  .carousel-template-4 label {
    left: 10%;
    top:auto;
    bottom:0;
  }

  .carousel-template-5 .carousel-img1 {
    width: 50%;
    left: 5%;
    right: auto;
    top:0%;
  }
  .carousel-template-5 .carousel-img2 {
    width: 69%;
    left: auto;
    right: 5%;
    bottom: auto;
    top: 37%;
  }
  .carousel-template-5 .carousel-img3 {
    width: 35%;
    left: 10%;
    right:auto;
    bottom: 6%;
    top: auto;
  }
  .carousel-template-5 label {
    left: 10%;
    top:auto;
    bottom:0;
  }

  .carousel-template-6 .carousel-img1 {
    width: 48%;
    left: auto;
    right: 6%;
    top: 0;
    bottom: auto;
  }
  .carousel-template-6 .carousel-img2 {
    width: 52%;
    left: 6%;
    right: auto;
    bottom: 6%;
    top: auto;
  }
  .carousel-template-6 .carousel-img3 {
    width: 32%;
    left: 5%;
    right: auto;
    top:5%;
    bottom: auto;

  }
  .carousel-template-6 label {
    left: 6%;
    bottom: 0;
    right: auto;
  }




  .carousel-template-7 .carousel-img1 {
    width: 60%;
    left: 3%;
    right: auto;
    top:0%;
    bottom:auto;
  }
  .carousel-template-7 .carousel-img2 {
    width: 50%;
    left: auto;
    right: 5%;
    bottom: auto;
    top: 42%;
  }
  .carousel-template-7 .carousel-img3 {
    width: 60%;
    left: auto;
    right: 20%;
    top: auto;
    bottom: 0;
  }

  .carousel-template-8 .carousel-img1 {
    width: 50%;
    left: 9%;
    right: auto;
    top:0%;
    bottom: auto;
  }
  .carousel-template-8 .carousel-img2 {
    width: 50%;
    left: auto;
    right: 5%;
    bottom: auto;
    top: 46%;
  }
  .carousel-template-8 .carousel-img3 {
    width: 40%;
    left: 30%;
    right: auto;
    top: auto;
    bottom: 0;
  }

  .carousel-template-9 .carousel-img1 {
    width: 80%;
    right: auto;
    left: 16%;
    bottom: auto;
    top: 48%;
  }
  .carousel-template-9 .carousel-img2 {
    width: 43%;
    left: 10%;
    right: auto;
    top:auto;
    bottom: 2%;
  }
  .carousel-template-9 .carousel-img3 {
    width: 70%;
    left: 5%;
    right: auto;
    top: 5%;
    bottom: auto
  }

  .carousel-template-10 .carousel-img1 {
    width: 66%;
    left: 5%;
    right: auto;
    top:0%;
    bottom: auto;
  }
  .carousel-template-10 .carousel-img2 {
    width: 40%;
    left: auto;
    right: 6%;
    top: 30%;
  }
  .carousel-template-10 .carousel-img3 {
    width: 60%;
    left: auto;
    right: 5%;
    bottom: 0;
    top: auto;
  }

  .carousel-template-11 .carousel-img1 {
    width: 50%;
    left: 20%;
    right: auto;
    top:auto;
    bottom: 0;
  }
  .carousel-template-11 .carousel-img2 {
    width: 62%;
    left: auto;
    right: 5%;
    top: 0%;
    bottom: auto;
  }
  .carousel-template-11 .carousel-img3 {
    width: 41%;
    left: 7%;
    right: auto;
    bottom: auto;
    top: 52%;
  }

  .carousel-template-12 .carousel-img1 {
    width: 40%;
    left: 6%;
    right: auto;
    top:0%;
    bottom: auto;
  }
  .carousel-template-12 .carousel-img2 {
    width: 58%;
    left: auto;
    right: 7%;
    top: 26%;
    bottom: auto;
  }
  .carousel-template-12 .carousel-img3 {
    width: 40%;
    left: 10%;
    right: auto;
    bottom: 0;
    top: auto;
  }

  .carousel-template-13 .carousel-img1 {
    width: 51%;
    left: 1%;
    right: auto;
    top:0%;
    bottom: auto;
  }
  .carousel-template-13 .carousel-img2 {
    width: 75%;
    left: auto;
    right: 5%;
    top: 30%;
    bottom: auto;
  }
  .carousel-template-13 .carousel-img3 {
    width: 43%;
    left: 36%;
    right: auto;
    bottom: 0;
    top: auto;
  }

  .carousel-template-14 .carousel-img1 {
    width: 90%;
    left: 5%;
    right: auto;
    top:28%;
    bottom: auto;
  }
  .carousel-template-14 .carousel-img2 {
    width: 60%;
    left: 15%;
    right: auto;
    top: 5%;
    bottom: auto;
  }
  .carousel-template-14 .carousel-img3 {
    width: 55%;
    left: auto;
    right: 5%;
    bottom: 0;
    top: auto;
  }

  .carousel-template-15 .carousel-img1 {
    width: 60%;
    left: 5%;
    right: auto;
    top:15%;
    bottom: auto;
  }
  .carousel-template-15 .carousel-img2 {
    width: 38%;
    left: auto;
    right: 5%;
    top: 0;
    bottom: auto;
  }
  .carousel-template-15 .carousel-img3 {
    width: 50%;
    left: 34%;
    right: auto;
    bottom: 0;
    top: auto;
  }

  .carousel-template-16 .carousel-img1 {
    width: 80%;
    left: 5%;
    right: auto;
    top:32%;
    bottom: auto;
  }
  .carousel-template-16 .carousel-img2 {
    width: 42%;
    left: auto;
    right: 3%;
    top: 0%;
    bottom: auto;
  }
  .carousel-template-16 .carousel-img3 {
    width: 50%;
    left: 32%;
    right: auto;
    bottom: 0;
    top:  auto;
  }

/* PROPER */

/* CHASSEY  */

/* BUZZFEED */

/* CURZON */



@media (min-width: 576px) {
    .carousel {
      height:700px;
      position: relative;
    }
}
@media (min-width: 768px) {
  
  .carousel-template-1 .carousel-img1 {
    width: 60%;
    left: auto;
    right: 1%;
    top:7%;
    bottom: auto;
  }
  .carousel-template-1 .carousel-img2 {
    width: 26%;
    left: 1%;
    bottom: auto;
    top: 0%;
    right: auto;
  }
  .carousel-template-1 .carousel-img3 {
    width: 28%;
    right: auto;
    left: 28%;
    bottom: 0;
    top: auto;
  }
  .carousel-template-1 label {
    top: 68%;
    left: 1%;
    bottom: auto;
  }

  .carousel-template-2 .carousel-img1 {
    width: 62%;
    left: 1%;
    right: auto;
    top:0;
    bottom: auto;
  }
  .carousel-template-2 .carousel-img2 {
    width: 34%;
    left: auto;
    right: 2%;
    bottom: auto;
    top: 10%;
  }
  .carousel-template-2 .carousel-img3 {
    width: 28%;
    left: auto;
    right: 22%;
    bottom: 0;
    top: auto;
  }
  .carousel-template-2 label {
    top: 71%;
    bottom: auto;
    width: 50%;
    right:auto;
    left: 1%;
  }
  

  .carousel-template-3 .carousel-img1 {
    width: 30%;
    left: 1%;
    right: auto;
    top:14%;
    bottom: auto;
  }
  .carousel-template-3 .carousel-img2 {
    width: 53%;
    left: auto;
    right: 1%;
    bottom: auto;
    top: 0%;
  }
  .carousel-template-3 .carousel-img3 {
    width: 42%;
    right: auto;
    left: 32%;
    top: 45%;
    bottom: auto;
  }
  .carousel-template-3 label {
    bottom: 0;
    top: auto;
    left: 32%;
    right: auto;
  }


  .carousel-template-4 .carousel-img1 {
    width: 59%;
    left: 2%;
    right: auto;
    top:0%;
    bottom: auto;
  }
  .carousel-template-4 .carousel-img2 {
    width: 29%;
    left: auto;
    right: 30%;
    bottom: auto;
    top: 60%;
  }
  .carousel-template-4 .carousel-img3 {
    width: 25%;
    left: auto;
    right: 2%;
    top: 7%;
    bottom: auto;
  }
  .carousel-template-4 label {
    left: 2%;
    top:68%;
    right: auto;
    bottom: auto;
  }

  .carousel-template-5 .carousel-img1 {
    width: 41%;
    left: 2%;
    right: auto;
    top:0%;
    bottom: auto;
  }
  .carousel-template-5 .carousel-img2 {
    width: 29%;
    left: auto;
    right: 35%;
    bottom: auto;
    top: 60%;
  }
  .carousel-template-5 .carousel-img3 {
    width: 25%;
    left: auto;
    right: 2%;
    top: 7%;
    bottom: auto;
  }
  .carousel-template-5 label {
    left: 2%;
    top:71%;
    right: auto;
    bottom: auto;
  }


  .carousel-template-6 .carousel-img1 {
    width: 38%;
    left: auto;
    right: 6%;
    bottom: 0;
    top: auto;
  }
  .carousel-template-6 .carousel-img2 {
    width: 30%;
    left: 6%;
    right: auto;
    bottom: 8%;
    top: auto;
  }
  .carousel-template-6 .carousel-img3 {
    width: 24%;
    left: 28%;
    right: auto;
    top:6%;
    bottom: auto;

  }
  .carousel-template-6 label {
    left: 6%;
    top:93%;
    bottom: auto;
    right: auto;
  }

  .carousel-template-7 .carousel-img1 {
    width: 34%;
    left: 3%;
    right: auto;
    top:0%;
    bottom:auto;
  }
  .carousel-template-7 .carousel-img2 {
    width: 46%;
    left: auto;
    right: 5%;
    bottom: auto;
    top: 0%;
  }
  .carousel-template-7 .carousel-img3 {
    width: 30%;
    left: 31%;
    right: auto;
    top: 60%;
    bottom: auto;
  }

  .carousel-template-8 .carousel-img1 {
    width: 25%;
    left: 1%;
    right: auto;
    top:0%;
    bottom: auto;
  }
  .carousel-template-8 .carousel-img2 {
    width: 59%;
    left: auto;
    right: 1%;
    bottom: auto;
    top: 7%;
  }
  .carousel-template-8 .carousel-img3 {
    width: 24%;
    left: 30%;
    right: auto;
    top: 56%;
    bottom: auto;
  }

  .carousel-template-9 .carousel-img1 {
    width: 42%;
    right: auto;
    left: 28%;
    bottom: auto;
    top: 43%;
  }
  .carousel-template-9 .carousel-img2 {
    width: 43%;
    left: 1%;
    right: auto;
    top:11%;
    bottom: auto;
  }
  .carousel-template-9 .carousel-img3 {
    width: 26%;
    left: auto;
    right: 1%;
    top: 5%;
    bottom: auto
  }

  .carousel-template-10 .carousel-img1 {
    width: 30%;
    left: 2%;
    right: auto;
    top:0%;
    bottom: auto;
  }
  .carousel-template-10 .carousel-img2 {
    width: 38%;
    left: auto;
    right: 2%;
    top: 10%;
  }
  .carousel-template-10 .carousel-img3 {
    width: 35%;
    left: 38%;
    right: auto;
    bottom: auto;
    top: 46%;
  }

  .carousel-template-11 .carousel-img1 {
    width: 28%;
    left: 1%;
    right: auto;
    top:18%;
    bottom: auto;
  }
  .carousel-template-11 .carousel-img2 {
    width: 31%;
    left: auto;
    right: 3%;
    top: 10%;
    bottom: auto;
  }
  .carousel-template-11 .carousel-img3 {
    width: 41%;
    left: 32%;
    right: auto;
    bottom: auto;
    top: 42%;
  }

  .carousel-template-12 .carousel-img1 {
    width: 32%;
    left: 2%;
    right: auto;
    top:10%;
    bottom: auto;
  }
  .carousel-template-12 .carousel-img2 {
    width: 30%;
    left: auto;
    right: 3%;
    top: 10%;
    bottom: auto;
  }
  .carousel-template-12 .carousel-img3 {
    width: 30%;
    left: 30%;
    right: auto;
    bottom: auto;
    top: 60%;
  }

  .carousel-template-13 .carousel-img1 {
    width: 31%;
    left: 1%;
    right: auto;
    top:20%;
    bottom: auto;
  }
  .carousel-template-13 .carousel-img2 {
    width: 59%;
    left: auto;
    right: 1%;
    top: 10%;
    bottom: auto;
  }
  .carousel-template-13 .carousel-img3 {
    width: 23%;
    left: 36%;
    right: auto;
    bottom: auto;
    top: 60%;
  }

  .carousel-template-14 .carousel-img1 {
    width: 41%;
    left: 1%;
    right: auto;
    top:0%;
    bottom: auto;
  }
  .carousel-template-14 .carousel-img2 {
    width: 42%;
    left: 29%;
    right: auto;
    top: 40%;
    bottom: auto;
  }
  .carousel-template-14 .carousel-img3 {
    width: 25%;
    left: auto;
    right: 1%;
    bottom: auto;
    top: 6%;
  }

  .carousel-template-15 .carousel-img1 {
    width: 30%;
    left: 2%;
    right: auto;
    top:0%;
    bottom: auto;
  }
  .carousel-template-15 .carousel-img2 {
    width: 28%;
    left: auto;
    right: 2%;
    top: 11%;
    bottom: auto;
  }
  .carousel-template-15 .carousel-img3 {
    width: 34%;
    left: 38%;
    right: auto;
    bottom: auto;
    top: 39%;
  }

  .carousel-template-16 .carousel-img1 {
    width: 28%;
    left: 1%;
    right: auto;
    top:17%;
    bottom: auto;
  }
  .carousel-template-16 .carousel-img2 {
    width: 31%;
    left: auto;
    right: 3%;
    top: 0%;
    bottom: auto;
  }
  .carousel-template-16 .carousel-img3 {
    width: 41%;
    left: 32%;
    right: auto;
    bottom: auto;
    top: 39%;
  }



  .carousel {
    height:400px;
    position: relative;
  }
}
@media (min-width: 992px) {
  .carousel {
    height:500px;
    position: relative;
  }
  .carousel-template-1 label {
    top: 70%;
  }
  .carousel-template-4 label {
    top:70%;
  }
  .carousel-template-2 label {
    top: 74%;
  }
  .carousel-template-5 .carousel-img1 {
    width: 40%;
  }
}

.arrow-button {
  position: absolute;
  z-index: 2;
  width: 20px;
  height: 25px;
  padding: 4px 2px;
  cursor: pointer;
  box-sizing: content-box;
  top:50%;
  background-color: rgba(255,255,255,0.3);
}
.arrow-left {
  left: 0px;
  transform: translate3d(0px, -20px, 0);
  -webkit-transform: translate3d(0px, -20px, 0);
  animation: arrowBounceLeft 1s infinite;
  -webkit-animation: arrowBounceLeft 1s infinite;
  animation-timing-function: ease-in-out;
  -webkit-animation-timing-function: ease-in-out;
}
.arrow-right {
  right: 0px;
  transform: translate3d(-0px, -20px, 0);
  -webkit-transform: translate3d(-0px, -20px, 0);
  animation: arrowBounceRight 1s infinite;
  -webkit-animation: arrowBounceRight 1s infinite;
    animation-timing-function: ease-in-out;
  -webkit-animation-timing-function: ease-in-out;
}
.arrow-button-svg {
  transition: 0.2s ease-out;
  -webkit-transition: 0.2s ease-out;
  width: 20px;
  height:25px;
  position: absolute;
}
.arrow-button-svg-dark {
  opacity: 1;
}
.arrow-button-svg-light {
  opacity: 0;
}
.arrow-right .arrow-button-svg  {
  transform: scaleX(-1);
}

.arrow-button-top {
  position: absolute;
   width: 100%;
  height:100%;
  background-color: #fff;
  border: 1px solid #000;
  -webkit-transition: 0.2s ease-out;
  transition: 0.2s ease-out;
}
.arrow-triangle {
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 7px 10px 7px 0;
  border-color: transparent #000000 transparent transparent;
  position: absolute;
}
.arrow-button:active {
  background-color: rgba(209,166,153,0.5);
}
.no-touch-device .arrow-button:hover > .arrow-button-svg-dark {
  opacity: 0;
}
.no-touch-device .arrow-button:hover > .arrow-button-svg-light {
  opacity: 1;
}

@keyframes arrowBounceLeft {
  0% {transform: translate3d(2px, -20px, 0);} 
  40% {transform: translate3d(0px, -20px, 0);} 
  100% {transform: translate3d(2px, -20px, 0);} 
}
@-webkit-keyframes arrowBounceLeft {
  0% {-webkit-transform: translate3d(2px, -20px, 0);} 
  40% {-webkit-transform: translate3d(0px, -20px, 0);} 
  100% {-webkit-transform: translate3d(2px, -20px, 0);} 
}
@keyframes arrowBounceRight {
  0% {transform: translate3d(-2px, -20px, 0);} 
  40% {transform: translate3d(0px, -20px, 0);} 
  100% {transform: translate3d(-2px, -20px, 0);} 
}
@-webkit-keyframes arrowBounceRight {
  0% {-webkit-transform: translate3d(-2px, -20px, 0);} 
  40% {-webkit-transform: translate3d(0px, -20px, 0);} 
  100% {-webkit-transform: translate3d(-2px, -20px, 0);} 
}

@media (min-width: 768px) {
  .arrow-left {
    transform: translate3d(0px, -20px, 0);
    -webkit-transform: translate3d(0px, -20px, 0);
    
  }
  .arrow-right {
    transform: translate3d(-0px, -20px, 0);
    -webkit-transform: translate3d(-0px, -20px, 0);
  }
  @keyframes arrowBounceLeft {
    0% {transform: translate3d(0px, -20px, 0);} 
    40% {transform: translate3d(-3px, -20px, 0);} 
    100% {transform: translate3d(0px, -20px, 0);} 
  }
  @-webkit-keyframes arrowBounceLeft {
    0% {-webkit-transform: translate3d(0px, -20px, 0);} 
    40% {-webkit-transform: translate3d(-3px, -20px, 0);} 
    100% {-webkit-transform: translate3d(0px, -20px, 0);} 
  }
  @keyframes arrowBounceRight {
    0% {transform: translate3d(0px, -20px, 0);} 
    40% {transform: translate3d(3px, -20px, 0);} 
    100% {transform: translate3d(0px, -20px, 0);} 
  }
  @-webkit-keyframes arrowBounceRight {
    0% {-webkit-transform: translate3d(0px, -20px, 0);} 
    40% {-webkit-transform: translate3d(3px, -20px, 0);} 
    100% {-webkit-transform: translate3d(0px, -20px, 0);} 
  }
}

</style>

<script>
import {slideshow} from '../../content.json'
// import ArrowButton from '../components/ArrowButton'
import ImageLoader from '../components/ImageLoader'
import Vue from 'vue'
import VueLazyload from 'vue-lazyload'

Vue.use(VueLazyload, {
  observer: true,
  throttleWait: 3000,
  // optional
  observerOptions: {
    rootMargin: '0px',
    threshold: 0.1
  },
  lazyComponent: true
})

export default {
  props: ['array'],
  data: function () {
    return {
      slideshow,
      myCaseStudies: [],
      imageCount: 0,
      clickindex: 0,
      mywidth: 0,
      imgwidth: 0,
      leftPos: 0,
      showLeft: true,
      showRight: true,
      startx: 0,
      imgcounter: 0,
      imgheight: 0,
      imgopacity: 0,
      gap: 105,
      blockRight: false,
      blockLeft: false
    }
  },
  methods: {
    checkLoaded: function () {
      this.imgcounter++
      if (this.imgcounter === this.imgs.length) {
        this.$nextTick(() => {
          this.imgheight = 'auto'
          setTimeout(() => {
            this.imgopacity = 1
          }, 50)
        })
      }
    },
    clickArrow (_val) {
      if (this.blockLeft || this.blockRight) return
      let val = _val
      this.$nextTick(() => {
        if (val === -1) {
          this.blockRight = true
          this.myCaseStudies.map((c, i) => {
            c['position'] += val
            if (c['position'] < -2) c['position'] = this.myCaseStudies.length - 3
          })
        }
        if (val === 1) {
          this.blockLeft = true
          this.myCaseStudies.map((c, i) => {
            c['position'] += val
            if (c['position'] > this.myCaseStudies.length - 3) c['position'] = -2
          })
        }
        setTimeout(() => {
          this.blockRight = false
          this.blockLeft = false
        }, 400)
      })
    },
    clickSlider: function (i) {
      // this.clickindex += i

      // if (this.clickindex < 0) this.clickindex = this.imgs.length
      // if (this.clickindex >= this.imgs.length) this.clickindex = 0

      // this.leftPos = 'translate3d(' + -(this.imgwidth * this.clickindex) + '%, 0, 0)'
      // this.showButtons()
    },
    showButtons: function (i) {
      this.showLeft = this.clickindex > 0
      this.showRight = this.clickindex < this.imgs.length - 1
    },
    setWidths: function () {
      this.mywidth = (this.imgs.length * this.gap)
      this.imgwidth = (this.gap / this.imgs.length)
    },
    startSwipe: function (evt) {
      this.startx = evt.changedTouches[0].clientX
    },
    moveSwipe: function (evt) {
      // evt.preventDefault()
    },
    endSwipe: function (evt) {
      let endx = evt.changedTouches[0].clientX
      if (this.startx > endx + 75) this.clickArrow(-1)
      if (this.startx < endx - 75) this.clickArrow(1)
    },
    handler: function () {
      this.myCaseStudies = this.slideshow[this.array]
      this.myCaseStudies.map((c, i) => {
        Vue.set(c, 'position', i - 2)
      })
    }
  },
  mounted: function () {
    this.handler()
  },
  computed: {
    // a computed getter
  },
  components: {
    ImageLoader
  }
}
</script>



// WEBPACK FOOTER //
// MyCarousel.vue?395c0be4